import React from 'react';
import { useSelector } from 'react-redux';
import { selectFilteredTenants } from '../store/slices/tenantSlice';

const TenantTable = ({ onEdit, onActivate, onDeactivate, onDelete }) => {
  const tenants = useSelector(selectFilteredTenants);
  
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
  };
  
  const thStyle = {
    textAlign: 'left',
    padding: '12px',
    backgroundColor: '#f9fafb',
    color: '#6b7280',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #e5e7eb'
  };
  
  const tdStyle = {
    padding: '12px',
    borderBottom: '1px solid #e5e7eb'
  };
  
  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: '500'
  };
  
  const masterBadgeStyle = {
    ...badgeStyle,
    backgroundColor: '#fef3c7',
    color: '#92400e'
  };
  
  const regularBadgeStyle = {
    ...badgeStyle,
    backgroundColor: '#dbeafe',
    color: '#1e40af'
  };
  
  const activeBadgeStyle = {
    ...badgeStyle,
    backgroundColor: '#d1fae5',
    color: '#065f46'
  };
  
  const inactiveBadgeStyle = {
    ...badgeStyle,
    backgroundColor: '#fee2e2',
    color: '#b91c1c'
  };
  
  const buttonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    marginRight: '12px'
  };
  
  const editButtonStyle = {
    ...buttonStyle,
    color: '#2563eb'
  };
  
  const activateButtonStyle = {
    ...buttonStyle,
    color: '#059669'
  };
  
  const deactivateButtonStyle = {
    ...buttonStyle,
    color: '#d97706'
  };
  
  const deleteButtonStyle = {
    ...buttonStyle,
    color: '#dc2626'
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Tenant Name</th>
            <th style={thStyle}>Type</th>
            <th style={thStyle}>Users</th>
            <th style={thStyle}>Based On</th>
            <th style={thStyle}>Expiry</th>
            <th style={thStyle}>Status</th>
            <th style={{...thStyle, textAlign: 'right'}}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tenants.length === 0 ? (
            <tr>
              <td colSpan="7" style={{...tdStyle, textAlign: 'center', color: '#6b7280'}}>
                No tenants found
              </td>
            </tr>
          ) : (
            tenants.map(tenant => (
              <tr key={tenant.id}>
                <td style={tdStyle}>
                  <div style={{ fontWeight: '500' }}>{tenant.name}</div>
                  {tenant.description && (
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{tenant.description}</div>
                  )}
                </td>
                <td style={tdStyle}>
                  <span style={tenant.is_master ? masterBadgeStyle : regularBadgeStyle}>
                    {tenant.is_master ? '👑 Master' : '🏢 Regular'}
                  </span>
                </td>
                <td style={tdStyle}>
                  {(tenant.total_services || 0)} / {tenant.max_users || 0}
                  <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>Max: {tenant.max_users || 100}</div>
                </td>
                <td style={tdStyle}>
                  {tenant.master_tenant_id ? 'Default Master' : '—'}
                </td>
                <td style={tdStyle}>
                  {tenant.expiry_date 
                    ? new Date(tenant.expiry_date).toLocaleDateString() 
                    : '—'}
                </td>
                <td style={tdStyle}>
                  <span style={tenant.is_active ? activeBadgeStyle : inactiveBadgeStyle}>
                    {tenant.is_active ? '✓ Active' : 'Inactive'}
                  </span>
                </td>
                <td style={{...tdStyle, textAlign: 'right', whiteSpace: 'nowrap'}}>
                  <button
                    onClick={() => onEdit(tenant)}
                    style={editButtonStyle}
                  >
                    Edit
                  </button>
                  
                  {tenant.is_active ? (
                    <button
                      onClick={() => onDeactivate(tenant.id)}
                      style={deactivateButtonStyle}
                    >
                      Deactivate
                    </button>
                  ) : (
                    <button
                      onClick={() => onActivate(tenant.id)}
                      style={activateButtonStyle}
                    >
                      Activate
                    </button>
                  )}
                  
                  {!tenant.is_master && (
                    <button
                      onClick={() => onDelete(tenant.id)}
                      style={deleteButtonStyle}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TenantTable;